import { writable } from 'svelte/store';

/* Fly Mode
* Si true alors affichage de la div du mode avion
*/
export const flyMode = writable(false);

/* Infos sur l'application
*/
export const app_version = writable({
    app_name: 'körtefa',
    version: '1.1.4' // !! Penser à modifier la version dans index.html !!!
})

/* Style square activé ou non
*/
export const square = writable(true);

/* Style deglingos activé ou non
*/
export const deglingos = writable(false);

/* Style minitel activé ou non
*/
export const minitel = writable(false);

/* Language english
*/
export const english = writable(false)

/* Activité
*/
export const activite = writable('enseigne commerciale');
/* Activity
*/
export const activity = writable('commercial brand');
/* Brand
*/
export const brand = writable('KÖRTEFA');
/* FullName
*/
export const fullName = writable('Yvan POIRIER');
/* Website
*/
export const website = writable('kortefa.net');
/*
*/
export const hide_cookie_param = writable(true);
export const is_analytics = writable(false);